import * as React from 'react';
import { Admin, Resource } from 'react-admin';
import PassmanList from './PassmanList';
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import PasswordEdit from './PasswordEdit';

const App = () => (
    <Admin dataProvider={dataProvider} authProvider={authProvider}>
        <Resource name="passwords" list={PassmanList} edit={PasswordEdit} />
    </Admin>
);

export default App;
